import Hrm from "../../../core/assets/images/Humanwrk_final.png";
import { Link, useLocation } from "react-router-dom";
import { STORAGE_URL } from "../../../core/constants";
import AdminOrUserToggleButton from "../adminOrUserToggleButton/AdminOrUserToggleButton";
import LanguageSwitcher from "../../LanguageSwitcher/LanguageSwitcher";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import NotificationIconTailwindComponent from "../notificationIconComponent/NotificationIconTailwindComponent";
import { BellAlertIcon, UserIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import ScreenSearch from "../../../pages/ScreenSearch/ScreenSearch";
import { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import logo from "../../../core/assets/images/templeLogo.svg";

export default function HeaderTailwindComponent({
  handleDrawerOpen,
  open,
  orgLogo,
  user,
  handleProfileClick,
  userLogout,
  PortalCheck,
}) {
  const location = useLocation();
  const [searchOpen, setSearchOpen] = useState(false);

  if (!user) return null;

  useEffect(() => {
    const ignoredPaths = ["/org/viewuser", "/org/edituser/view"];
    const newPath = location.pathname;
    if (!ignoredPaths.includes(newPath)) {
      sessionStorage.removeItem("selectedOrg");
    }
  }, [location.pathname]);

  return (
    <Disclosure
      as="nav"
      className={`fixed z-50 shadow-sm w-full overflow-visible min-w-screen`}
    >
      <div
        className={`bg-[#F2C646] fixed pl-1 w-full shadow-[0_4px_18px_0_rgba(0,0,0,0.25)] transition-transform duration-500 ease-in-out transform `}
      >
        <div className="flex h-16 justify-between">
          <div className="flex w-full justify-between">
            <div className="flex justify-center items-center">


              <div className="flex shrink-0 items-center relative z-50">
                {!open && (
                  <button
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    className="flex items-center justify-center w-13 h-13 cursor-pointer"
                  >
                    <Bars3Icon className="h-8 w-7 text-black" />
                  </button>
                )}
              </div>


              {!open && (
                <div className="flex-shrink-0">
                  <Link to="/">
                    <div className="flex items-center justify-center md:justify-start sm:mt-[2px]">
                      {/* Logo */}
                      <div className="w-[90px] h-[50px] -ml-[16px] !sm:-ml-[20px]">
                        <img
                          src={logo}
                          className="w-full h-full object-contain"
                          alt="Temple Hub Logo"
                        />
                      </div>

                      {/* Name */}
                      {/* <div className="font-bold text-[20px] -ml-[6px] text-slate-800 whitespace-nowrap !sm:text-[16px]">
                        Temple <span className="text-red-600">Hub</span>
                      </div> */}
                    </div>
                  </Link>
                </div>
              )}
            </div>

            <div className="flex md:ml-6 md:space-x-4 md:pr-3 !justify-end">
              <div className="hidden md:block max-w-[700px] px-2 sm:px-4">
                <ScreenSearch />
              </div>

              <div className="block md:hidden relative px-2">
                <button
                  onClick={() => setSearchOpen(!searchOpen)}
                  className="flex items-center justify-center p-1 mt-[11px] md:mr-4 rounded-full bg-white shadow hover:bg-gray-100"
                >
                  <MagnifyingGlassIcon className="w-8 h-8 text-black" />
                </button>

                {searchOpen && (
                  <div className="absolute mt-2 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-lg p-0 z-50">
                    <ScreenSearch />
                  </div>
                )}
              </div>

              <div className="flex items-center lg:mr-2">
                <LanguageSwitcher />
              </div>

              {[1, 2].includes(PortalCheck) && (
                <div
                  className="
  mt-1 
  w-[60px] 
  sm:w-[50px] 
  flex 
  items-center 
  mx-1        /* small screens margin left + right */
  lg:ml-4 
  lg:mr-0
"
                >
                  <AdminOrUserToggleButton />
                </div>
              )}

              <div className="relative flex items-center gap-1 ml-1 lg:ml-5 md:pr-1">
                <NotificationIconTailwindComponent />

                <Menu
                  as="div"
                  className="relative ml-2 md:ml-5 appearance-none"
                >
                  <div>
                    <MenuButton className="relative flex rounded-full bg-white text-sm !h-11 !w-8">
                      <span className="sr-only">Open user menu</span>
                      <img
                        alt="Profile Pic"
                        src={
                          user?.imageUrl &&
                            user.imageUrl.includes("googleusercontent.com")
                            ? user.imageUrl
                            : user.imageUrl
                              ? STORAGE_URL + user.imageUrl
                              : "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80"
                        }
                        referrerPolicy="no-referrer"
                        className="rounded-full"
                      />
                    </MenuButton>
                  </div>

                  <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-58 origin-top-right rounded-md bg-white py-2 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden"
                  >
                    <MenuItem>
                      <div
                        onClick={handleProfileClick}
                        className="block px-4 py-2 text-md text-gray-700 hover:bg-gray-100 cursor-pointer"
                      >
                        Your Profile
                      </div>
                    </MenuItem>

                    <MenuItem>
                      <div
                        onClick={userLogout}
                        className="block px-4 py-2 text-md text-gray-700 hover:bg-gray-100 cursor-pointer"
                      >
                        Log out
                      </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>

              {/* <div className="hidden md:flex items-center flex-none mr-[-8px]">
                <img
                  src={STORAGE_URL + orgLogo}
                  className="logoorg w-32 !h-10 md:w-40 md:h-10 !lg:w-60 !lg:h-10"
                  alt="logo"
                />
              </div> */}
            </div>
          </div>

          <div className="mr-2 -ml-2 flex items-center md:hidden">
            <Menu as="div" className="relative ml-3 appearance-none">
              <div>
                <Menu.Button className="relative flex text-sm">
                  <span className="sr-only">Open user menu</span>
                  {/* <img
                    src="/musquareLetter.png"
                    alt="musquare letter icon"
                    className="w-12 h-12"
                  /> */}

                  <XMarkIcon className="hidden h-10 w-10 group-data-open:block" />
                </Menu.Button>
              </div>

              <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none">
                <Menu.Item>
                  {({ active }) => (
                    <div
                      className={`flex items-center gap-2 px-4 py-2 text-sm text-gray-700 ${active ? "bg-gray-100" : ""
                        }`}
                    >
                      <BellAlertIcon className="h-5 w-5 text-gray-500" />
                      Notification
                    </div>
                  )}
                </Menu.Item>

                <Menu.Item>
                  {({ active }) => (
                    <div
                      onClick={handleProfileClick}
                      className={`flex items-center gap-2 px-4 py-2 text-sm text-gray-700 cursor-pointer ${active ? "bg-gray-100" : ""
                        }`}
                    >
                      <UserIcon className="h-5 w-5 text-gray-500" />
                      Profile
                    </div>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Menu>
          </div>
        </div>
      </div>

      <DisclosurePanel className="md:hidden">
        <div className="space-y-1 pt-2 pb-3">
          <DisclosureButton
            as="a"
            href="#"
            className="block border-l-4 border-indigo-500 bg-indigo-50 py-2 pr-4 pl-3 text-base font-medium text-indigo-700 sm:pr-6 sm:pl-5"
          >
            Dashboard
          </DisclosureButton>

          <DisclosureButton
            as="a"
            href="#"
            className="block border-l-4 border-transparent py-2 pr-4 pl-3 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700 sm:pr-6 sm:pl-5"
          >
            Team
          </DisclosureButton>

          <DisclosureButton
            as="a"
            href="#"
            className="block border-l-4 border-transparent py-2 pr-4 pl-3 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700 sm:pr-6 sm:pl-5"
          >
            Projects
          </DisclosureButton>

          <DisclosureButton
            as="a"
            href="#"
            className="block border-l-4 border-transparent py-2 pr-4 pl-3 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700 sm:pr-6 sm:pl-5"
          >
            Calendar
          </DisclosureButton>
        </div>

        <div className="border-t border-gray-200 pt-4 pb-3">
          <div className="flex items-center px-4 sm:px-6">
            <div className="shrink-0">
              <img
                alt=""
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                className="h-10 w-10 rounded-full"
              />
            </div>

            <div className="ml-3">
              <div className="text-base font-medium text-gray-800">
                Tom Cook
              </div>
              <div className="text-sm font-medium text-gray-500">
                tom@example.com
              </div>
            </div>

            <button
              type="button"
              className="relative ml-auto shrink-0 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
            >
              <BellIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>

          <div className="mt-3 space-y-1">
            <DisclosureButton
              as="a"
              href="#"
              className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 sm:px-6"
            >
              Your Profile
            </DisclosureButton>

            <DisclosureButton
              as="a"
              href="#"
              className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 sm:px-6"
            >
              Settings
            </DisclosureButton>

            <DisclosureButton
              as="a"
              href="#"
              className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 sm:px-6"
            >
              Sign out
            </DisclosureButton>
          </div>
        </div>
      </DisclosurePanel>
    </Disclosure>
  );
}
